// import axios from 'axios';
import axios from 'axios'
import _ from 'lodash'
import NProgress from 'nprogress'
import { logout } from './index'
import config from '../config/user.env.js'
import store from '../store'
import { ElMessage } from 'element-plus'
import { getToken, WHITE_REQUEST_LIST } from '@/utils/auth'
import { debounce } from 'lodash'
import { HttpEncrypt } from '@/utils/httpEncrypt'

const RESPONSE_STATUS = {
    OK: 200,
    BAD_REQUEST: 400,
    NOT_LOGIN: 401,
    NO_PERMISSON: 403,
    NOT_FOUND: 404,
    METHOD_NOT_ALLOWED: 405,
    SERVER_ERROR: 500,
    BAD_GATEWAY: 502,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504,
}
const RESPONE_EORROR = {
    BAD_REQUEST: '请求出现错误',
    // NOT_LOGIN: '',
    NO_PERMISSON: '请求资源被拒绝',
    NOT_FOUND: '没有找到接口信息',
    METHOD_NOT_ALLOWED: '请求方法不支持',
    SERVER_ERROR: '系统异常',
    BAD_GATEWAY: '网关错误',
    SERVICE_UNAVAILABLE: '服务不可用',
    GATEWAY_TIMEOUT: '网关超时',
    NETWORK_ERROR: '系统暂时出现问题，请稍后再试，如果问题仍然存在，请联系我们的客服人员寻求帮助！',
}
const TIMEOUT = 1000
const MILLISECOND_PER_MINUTE = 60000
const MINUTES = 30
const PAUSE_SECONDS = 3
const service = axios.create({
    withCredentials: false,
    baseURL: config.apiUrl, // api 的 base_url
    timeout: MILLISECOND_PER_MINUTE * MINUTES, // 请求超时时间
})

// 已独立化改造的服务
const ANNTO_PREFIXS = ['/api-xxx']
// 独立化改造新接口域名
const ANNTO_REQ_DOMAIN = {
    SIT: 'https://anapi-sit.annto.com',
    UAT: 'https://anapi-uat.annto.com',
    VER: 'https://anapi-ver.annto.com',
    PROD: 'https://anapi.annto.com',
}

service.jsonp = (url, data) => {
    // jsonp跨域封装
    if (!url) {
        throw new Error('url is necessary')
    }
    const strStart = 9
    const strLength = 18
    const callback = 'CALLBACK' + Math.random().toString().substr(strStart, strLength)
    data.callback = callback
    const JSONP = document.createElement('script')
    JSONP.setAttribute('type', 'text/javascript')
    const headEle = document.getElementsByTagName('head')[0]
    let ret = ''
    if (data) {
        if (typeof data === 'string') {
            ret = '&' + data
        } else if (typeof data === 'object') {
            // eslint-disable-next-line guard-for-in
            Object.keys(data).forEach(key => {
                ret += '&' + key + '=' + encodeURIComponent(data[key])
            })
        }
        ret += '&_time=' + Date.now()
    }
    JSONP.src = `${url}?callback=${callback}${ret}`
    return new Promise(resolve => {
        window[callback] = r => {
            resolve(r)
            headEle.removeChild(JSONP)
            delete window[callback]
        }
        headEle.appendChild(JSONP)
    })
}

HttpEncrypt.instance.setup(service)

/**
 * 用于 reqeust 的 options
 */
const parseRequestOptions = configuration => {
    const { headers } = configuration.options || {}
    return { headers }
}

/**
 * 用于 response 的 options
 */
const parseResponseOptions = response => {
    const { silent, passError } = response.config.options || {}
    return { silent, passError }
}

const handleRequestHeaders = (con, options) => {
    const currentTenant = store.state.user.currentTenant
    const tenantCode = currentTenant ? currentTenant.tenantCode : null
    const whiteUrl = WHITE_REQUEST_LIST.find(item => con.url.includes(item))

    if (tenantCode) {
        con.headers.tenantCode = tenantCode
    }

    if (getToken()) {
        con.headers[config.environment] = 'token=' + getToken()
    } else if (whiteUrl) {
        // 当请求的接口包含在白名单接口时带上 whiteUrl 值
        con.headers[config.environment] = 'whiteUrl=' + whiteUrl
    }

    // 设置额外的 request header
    if (options.headers) {
        for (const [hk, hv] of Object.entries(options.headers)) {
            con.headers[hk] = hv
        }
    }
}

// request拦截器
service.interceptors.request.use(
    con => {
        NProgress.start()
        const options = parseRequestOptions(con)

        // 根据接口是否已完成改造来判断使用新接口域名
        const isAnntoPrefix = ANNTO_PREFIXS.some(prefix => con.url.includes(prefix))
        con.baseURL = isAnntoPrefix ? ANNTO_REQ_DOMAIN[config.env] : config.apiUrl

        // cookies.remove(config.MAS_TGC, { domain: '.annto.com' });

        handleRequestHeaders(con, options)

        // 过滤get请求的空参数（null, undefined, ''）
        con.params = _.chain(con)
            .get('params')
            .toPairs()
            .map(arr => _.map(arr, _.trim))
            .filter(arr => !_.isNil(arr[1]) && arr[1] !== '')
            .fromPairs()
            .value()

        return con
    },
    error => {
        NProgress.done()
        Promise.reject(error)
    },
)

/** 防抖抛出错误 */
const mkReportErrorDebounce = () =>
    debounce(msg => {
        ElMessage.error(msg)
    }, 500)

const reporters = {
    [RESPONSE_STATUS.NOT_LOGIN]: mkReportErrorDebounce(),
    [RESPONSE_STATUS.NO_PERMISSON]: mkReportErrorDebounce(),
}

function reportError(msg, { silent = false, statusCode } = {}) {
    if (!silent) {
        const reporter = reporters[parseInt(statusCode)]
        if (reporter) {
            reporter(msg)
        } else {
            ElMessage.error(msg)
        }
    }
}

// respone拦截器
service.interceptors.response.use(
    // eslint-disable-next-line complexity
    response => {
        NProgress.done()
        const { silent, passError } = parseResponseOptions(response)
        // eslint-disable-next-line max-len
        if (
            (response.data && Number(response.data.code) === RESPONSE_STATUS.NOT_LOGIN) ||
            (response.data && Number(response.data.code) === RESPONSE_STATUS.NO_PERMISSON)
        ) {
            reportError(response.data.msg, { silent, statusCode: response.data.code })

            // 公众号-账号绑定页面，登录校验返回401时，走返回response.data
            if (silent) {
                return response.data
            } else {
                setTimeout(() => {
                    logout()
                }, TIMEOUT)
            }
        } else if (
            response.data &&
            response.data.code &&
            response.data.code !== '0' &&
            +response.data.code !== RESPONSE_STATUS.OK &&
            !passError
        ) {
            reportError(response.data.msg, { silent })
            return response.data
        } else {
            return response.data
        }
    },
    // eslint-disable-next-line complexity
    error => {
        NProgress.done()
        const response = Object.assign({}, error.response)
        if (response) {
            switch (response.status) {
                case RESPONSE_STATUS.BAD_REQUEST: // 400
                    // ElMessage.error(RESPONE_EORROR.BAD_REQUEST)
                    reportError(RESPONE_EORROR.BAD_REQUEST, { statusCode: RESPONSE_STATUS.BAD_REQUEST })
                    break
                case RESPONSE_STATUS.NOT_LOGIN: // 401
                    // 登出节流
                    if (window.t) {
                        clearTimeout(window.t)
                    }
                    window.t = setTimeout(function () {
                        logout()
                    }, PAUSE_SECONDS * 1000)

                    break
                case RESPONSE_STATUS.NO_PERMISSON: // 403
                    // ElMessage.error(RESPONE_EORROR.NO_PERMISSON)
                    reportError(RESPONE_EORROR.NO_PERMISSON, { statusCode: RESPONSE_STATUS.NO_PERMISSON })
                    break
                case RESPONSE_STATUS.NOT_FOUND: // 404
                    // ElMessage.error(RESPONE_EORROR.NOT_FOUND)
                    reportError(RESPONE_EORROR.NOT_FOUND, { statusCode: RESPONSE_STATUS.NOT_FOUND })
                    break
                case RESPONSE_STATUS.METHOD_NOT_ALLOWED: // 405
                    // ElMessage.error(RESPONE_EORROR.METHOD_NOT_ALLOWED)
                    reportError(RESPONE_EORROR.METHOD_NOT_ALLOWED, { statusCode: RESPONSE_STATUS.METHOD_NOT_ALLOWED })
                    break
                case RESPONSE_STATUS.SERVER_ERROR: // 500
                    // ElMessage.error(RESPONE_EORROR.SERVER_ERROR)
                    reportError(RESPONE_EORROR.SERVER_ERROR, { statusCode: RESPONSE_STATUS.SERVER_ERROR })
                    break
                case RESPONSE_STATUS.BAD_GATEWAY: // 502
                    // ElMessage.error(RESPONE_EORROR.BAD_GATEWAY)
                    reportError(RESPONE_EORROR.BAD_GATEWAY, { statusCode: RESPONSE_STATUS.BAD_GATEWAY })
                    break
                case RESPONSE_STATUS.SERVICE_UNAVAILABLE: // 503
                    // ElMessage.error(RESPONE_EORROR.SERVICE_UNAVAILABLE)
                    reportError(RESPONE_EORROR.SERVICE_UNAVAILABLE, { statusCode: RESPONSE_STATUS.SERVICE_UNAVAILABLE })
                    break
                case RESPONSE_STATUS.GATEWAY_TIMEOUT: // 504
                    // ElMessage.error(RESPONE_EORROR.GATEWAY_TIMEOUT)
                    reportError(RESPONE_EORROR.GATEWAY_TIMEOUT, { statusCode: RESPONSE_STATUS.GATEWAY_TIMEOUT })
                    break
                default:
                    // ElMessage.error(RESPONE_EORROR.NETWORK_ERROR)
                    reportError(RESPONE_EORROR.NETWORK_ERROR)
            }
        }
        return Promise.reject(error)
    },
)

export default service
